import styled from "styled-components";

export const ContainerAffiliateProgram = styled.div`
  max-width: 81rem;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  position: relative;
  height: auto;

  margin-bottom: 3rem;

  .navigation-affiliates {
    display: flex;
    align-items: center;

    width: 100%;
    gap: 0.5rem;
    align-self: center;

    h1,
    h2 {
      margin-bottom: 0;
      font-size: 1.25rem;
      font-weight: 600;
    }

    p {
      color: ${({ theme }) => theme.controlPanel?.primaryTextTable};
      font-size: 1.25rem;
      margin-bottom: 0;
      cursor: pointer;
    }

    h1 {
      color: ${({ theme }) => theme.controlPanel?.primaryTextTable};
      cursor: pointer;
    }

    h2 {
      color: ${({ theme }) => theme.controlPanel?.secondaryButton};
    }

    svg {
      color: ${({ theme }) => theme.controlPanel?.primaryTextTable};
      font-size: 1rem;
    }
    @media screen and (max-width: 1099px) {
      h1,
      h2 {
        font-size: 1rem;
      }
    }
  }
`;

export const AffiliateProgramSection = styled.section`
  display: flex;
  gap: 1.5rem;

  flex-direction: column;
`;

export const ContentMetricsAffiliateProgram = styled.section`
  display: flex;
  gap: 1.5rem;
  @media screen and (max-width: 1099px) {
    flex-wrap: wrap;
  }

  .loader {
    width: 100%;
    align-items: center;
  }
`;

export const SectionSearch = styled.div`
  display: flex;
  gap: 1rem;
  position: relative;
`;
